import React, { PureComponent } from 'react';
import {
    AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import { Typography, Grid } from '@material-ui/core';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';

const getPercent = (value, total) => {
    const ratio = total > 0 ? value / total : 0;

    return toPercent(ratio, 2);
};

const colors = {
    main: '#222',
    dead: '#000',
    infected: '#6CB4EE',
    recovered: '#4F7942',
    healthy: '#fff',
}
const nameMapper = {
    'dead': 'Gestorben',
    'infected': 'Infiziert',
    'recovered': 'Genesen',
    'healthy': 'Gesund',
}

const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;
const renderTooltipContent = (o) => {
    const { payload } = o;
    const total = payload.reduce((result, entry) => (result + entry.value), 0);
    const useEntryColor = false;
    return (
        <div className="customized-tooltip-content">
            <ul className="list" style={{ listStyleType: 'none' }}>
                {
                    payload.reverse().map((entry, index) => (
                        <li key={`item-${index}`} style={{ color: useEntryColor ? entry.color : colors.main, lineHeight: '1.8' }}>
                            {`${nameMapper[entry.name]}: ${entry.value} (${getPercent(entry.value, total)})`}
                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

const renderLegend = (props) => {
    const { payload } = props;
    const coloredText = false;
    return (
        <div >
            <Divider orientation="vertical" absolute style={{ marginLeft: '25px', paddingTop: '13px', marginBottom: '-12px', paddingBottom: '12px' }} />
            <Typography style={{ marginLeft: '30px' }} align='left'>
                <Box fontWeight="fontWeightMedium" m={1}>
                    Legende
                </Box>
            </Typography>
            <ul style={{ listStyleType: 'none' }}>
                {
                    payload.reverse().map((entry, index) => (
                        <li key={`item-${index}`} style={{ alignItems: "center", marginTop: '0px', marginBottom: '6px' }}>
                            <Grid container alignItems="center" alignContent="center">
                                {index !== 0 ? <FiberManualRecordIcon style={{ color: colors[Object.keys(colors)[4 - index]] }} size={18} />
                                    : <FiberManualRecordOutlinedIcon style={{ color: '#000' }} size={18} />}
                                <Typography style={{ color: coloredText ? colors[Object.keys(colors)[4 - index]] : '#666' }}>
                                    <Box fontSize={16}>
                                        {nameMapper[entry.value]}e Personen
                                     </Box>
                                </Typography>
                            </Grid>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
}

const numberFormatter = (number) => `Tag ${number}`;

export default class MyChart extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: [{ healthy: props.settings.amount - 1, infected: 1, dead: 0, recovered: 0, number: 1 }],
            width: this.props.width,
            height: this.props.height,
            defaultData: [{ healthy: props.settings.amount - 1, infected: 1, dead: 0, recovered: 0, number: 1 }]
        }
    }

    setDefault = (settings) => {
        this.setState({
            defaultData: [{ healthy: settings.amount - 1, infected: 1, dead: 0, recovered: 0, number: 1 }],
        }, () => this.state.data.length === 1 ? this.setState({ data: this.state.defaultData }) : '');
    }

    addData = (newData) => {
        this.setState({ data: [...this.state.data, newData] });
    }

    clear = () => {
        this.setState({
            data: this.state.defaultData
        });
    }

    updateDimensions = () => {
        this.setState({ width: this.state.width, height: this.state.height });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    linesBlack = false;
    render() {
        return (
            <AreaChart
                width={this.state.width}
                height={this.state.height - 1}
                data={this.state.data}
                stackOffset="expand"
                margin={{
                    top: 20, right: 30, left: 0, bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis tickFormatter={numberFormatter} dataKey="number" />
                <YAxis tickFormatter={toPercent} />
                <Tooltip content={renderTooltipContent} />
                {<Legend layout="vertical" verticalAlign="middle" align="right" iconType="plainline" content={renderLegend} />}
                <Area type="monotone" dataKey="dead" stackId="1" stroke={this.linesBlack ? colors.main : colors.dead} fill={colors.dead} />
                <Area type="monotone" dataKey="infected" stackId="1" stroke={this.linesBlack ? colors.main : colors.infected} fill={colors.infected} />
                <Area type="monotone" dataKey="recovered" stackId="1" stroke={this.linesBlack ? colors.main : colors.recovered} fill={colors.recovered} />
                <Area type="monotone" dataKey="healthy" stackId="1" stroke={this.linesBlack ? colors.main : colors.healthy} fill={colors.healthy} />
            </AreaChart>
        );
    }
}